const AppLogout = ({ children }) => {
  console.debug('[auth] AppLogout wrapper mounted; inactivity logout is disabled.');
  return children;
};

export default AppLogout;
